import type {
  IContractType,
  ICurrentJob,
  IInitialBalance,
  IJobsLeave,
  ILeaveFormula,
  ILeaveTypes,
  IOffice,
  IPublicHolidays,
  IResource,
  IResourceRecruitmentDate,
  ILeaveRow,
  ILeave,
  ITakenDay,
  IManualAcquisition
} from '../../interface/src/index.ts'

import {
  getFiscalYear,
  isinArray,
} from '../../common/src/index.ts'
import { getJobOnDay } from '../../resource/src/index.ts'

export { leaveFormulas, yearlyAcquisition } from './leaveFormulas.ts'
export { REMOTE_LEAVE_FORMULA_IDS, isRemoteLeaveType } from './remote.ts'



/**
 * Filter the type of leave
 * @param leaveTypesAll
 * @param user
 * @return Array<ILeaveType>
 */
export function filterLeaveTypes(
  leaveTypesAll: Array<ILeaveTypes & {
    formula:ILeaveFormula
  } >,
  user: IResource,
): Array<ILeaveTypes & {
  formula:ILeaveFormula
} > {
  // The job covering today, its last day included
  let currentJob = getJobOnDay(user, new Date())

  if (!currentJob && !user.departureDate){
    return []
  }
  else if(!currentJob && !!user.departureDate){
    let departureDate = new Date(user.departureDate);
    departureDate.setDate(departureDate.getDate()-1)
    currentJob = getJobOnDay(user, departureDate);
  }
    
  const countryId = typeof user.countryId === 'string' ? user.countryId : user.countryId?._id
  const officeId = typeof user.officeId === 'string' ? user.officeId : user.officeId?._id
  const positionId = typeof currentJob.positionId === 'string' ? currentJob.positionId : currentJob.positionId._id
  const contractType = currentJob.contractType ? (typeof currentJob.contractType === 'string' ? currentJob.contractType : currentJob.contractType._id) : ''
  const gender  = user.gender===0?'male':(user.gender===1?'female':'other')
  const result = leaveTypesAll.filter((currentLeaveType) => {

    if (typeof currentLeaveType.formula === 'number')
      throw new Error(`formula ${currentLeaveType.formula} is not populated`)


    if (currentLeaveType?.gender === 'male' || currentLeaveType?.gender === 'female') {
      if (currentLeaveType?.gender !== gender)
        return false
    };

    let isJob = true;
    if (currentLeaveType.jobs?.length > 0)
      isJob = isinArray(currentLeaveType.jobs as Array<IJobsLeave>, positionId)

    else if (currentLeaveType.jobsExcluded.length > 0)
      isJob = !isinArray(currentLeaveType.jobsExcluded as Array<IJobsLeave>, positionId)

    if (currentLeaveType.targetContract.length > 0)
      return isJob && isinArray(currentLeaveType.targetContract as Array<IContractType>, contractType)

    else if (currentLeaveType.targetOffices.length > 0)
      return isJob && isinArray(currentLeaveType.targetOffices as Array<IOffice>, officeId as 'string')

    else if (currentLeaveType.targetResources.length > 0)
      return isinArray(currentLeaveType.targetResources as Array<IResourceRecruitmentDate>, user._id)

    else
      return isJob && currentLeaveType.formula?.country?.toLowerCase() == countryId?.toLowerCase()

    // const isRightCountry = currentLeaveType.formula.country.toLowerCase() == countryId?.toLowerCase();

    /* return (
      (containTargetOffices || containTargetResources || containJob) && isRightCountry
    ); */
  }).sort((a, b) => a.order - b.order);

  return result;
}

/**
 * Get the public holidays
 * @param year
 * @param publicHolidays
 * @param office
 * @returns Array<Date | string>
 */
export function getPublicHolidays(
  year: number,
  currentJob: ICurrentJob | null,
  publicHolidays: Array<IPublicHolidays>,
  office: IOffice,
): Array<Date | string> {
  if (office) {
    publicHolidays = publicHolidays.filter((obj) => {
      if (office.countryId !== null) {
        return (
          obj.country.toLowerCase()
          == (typeof office.countryId === 'string'
            ? office.countryId
            : office.countryId._id
          ).toLowerCase()
        )
      }
    })
    if (publicHolidays.length > 0) {
      const years = publicHolidays[0].holidays.filter((obj) => {
        
        if(office.region){
          if(obj.region == office.region){
            return obj.year == year
          }
          else{
            return false
          }
        }
        else{
          return obj.year == year;
        }
      })
      
      if (years.length > 0)
        return years[0].days
      else
        return []
    }
    else {
      return []
    }
  }
  else {
    return []
  }
}

const getJobInPeriod = (
  { jobs }: any,
  date: Date,
) =>{

  const thisJob = jobs.find((el: { startDate: Date | string ; endDate: Date | string | null }) => 
    date >= new Date(el.startDate) && (!el.endDate || date <= new Date(el.endDate))
  )

  if(!thisJob || thisJob.isAlumni){
    return null;
  }

  return thisJob;
}

const getJobInPeriod2 = (
  { jobs }: any,
  date: Date,
) => {
  const earliestJob = getEarliestJob({ jobs })

  for (let k = 0; k < jobs.length; k++) {
    const userStartDate = new Date(jobs[k].startDate)
    userStartDate.setHours(0, 0, 0, 0)

    if (earliestJob && earliestJob._id == jobs[k]._id)
      userStartDate.setHours(0, 0, 0, 1)

    if (userStartDate <= date && !jobs[k].endDate)
      return jobs[k]

    if (jobs[k].endDate && userStartDate <= date && new Date(jobs[k].endDate as string) >= date) {
      if (jobs[k].isAlumni)
        return null

      return jobs[k]
    }
    if (!jobs[k].startDate)
      return jobs[k]
  }
  return null
}

const getEarliestJob = ({ jobs }: Array<{ _id: string; startDate: string | Date }> | any): any => {
  let thisJob = null
  if (!jobs || !jobs.length)
    return null
  let thisDate = new Date(jobs[0].startDate)
  thisJob = jobs[0]
  for (let i = 0; i < jobs.length; i++) {
    if (new Date(jobs[i].startDate).getTime() < thisDate.getTime()) {
      thisDate = new Date(jobs[i].startDate)
      thisJob = jobs[i]
    }
  }
  return thisJob
}


export const getPendingValidator = (leave: any) => {
  const pendingValidation = leave.validation.find((val: any) => val.validationDate === null && !val.isOverwritten) || {}
  return pendingValidation.validatedResource || pendingValidation.validatedByPopulated || pendingValidation.validatedBy
}

export const getFinalValidator = (leave: any) => {
  const currentPendingValidator = getPendingValidator(leave)
  if(currentPendingValidator) return currentPendingValidator
  const finalValidator = leave.validation.reduce((max: any, val: any) => (max._created > val._created ? max : val));
  return finalValidator.validatedResource || finalValidator.validatedByPopulated
}





// ******************************* NEW *****************************
// ******************************* NEW *****************************
// ******************************* NEW *****************************
// ******************************* NEW *****************************
// ******************************* NEW *****************************
// ******************************* NEW *****************************
// ******************************* NEW *****************************


// Calculer le mois fiscal de départ
export function getFiscalMonthStart(user: IResource): number {

  if (user.firm && typeof user.firm === 'string'){
    throw new Error('user.firm is not populated')
  }
  else if(!user.firm && user._firmId && typeof user._firmId === 'string'){
    throw new Error('user._firmId is not populated')
  }

  const firm = user.firm?._id ? user.firm : user._firmId

  if (typeof firm === 'string')
    throw new Error('resource._firmId is not populated')

  if(typeof user.invoicingInformation === 'string' || !user.invoicingInformation){
    return firm.fiscalMonthStart;
  }
  else{
    return user.invoicingInformation.fiscalMonthStart;
  }

}

// Fonction pour récupérer les initialBalances pour un IUser donné
export function getInitialBalancesForUser(userId: string, leaveTypes: ILeaveTypes[]): IInitialBalance[] {
  const initialBalances: IInitialBalance[] = [];

  leaveTypes.forEach((leaveType) => {
    leaveType.initialBalances = leaveType.initialBalances || []
    
    leaveType.initialBalances.forEach((balance) => {
      const balanceResourceId = (typeof balance.resourceId === 'string'?balance.resourceId:balance.resourceId._id)
      if (balanceResourceId === userId) {

        const leavePeriods = balance.leavePeriods.filter(period => !period.isManual).map(period => ({
          balance: period.balance,
          initialBalance: period.balance, // Vous pouvez ajuster cela si nécessaire
          periodDisplay: period.periodDisplay || '',
          type:leaveType._id,
          period: period.period,
          startDate: period.startDate,
          acquired: 0, // Initialiser si nécessaire
          taken: 0, // Initialiser si nécessaire
        }));

        if(leavePeriods.length>0){
          initialBalances.push({
            _id: balance._id,
            leavePeriods: leavePeriods
          });
        }
      }
    });
  });

  return initialBalances;
}


// Fonction pour récupérer les manualAcquisitions pour un IUser donné
export function getManualAcquisitionsForUser(userId: string, leaveTypes: ILeaveTypes[]): IManualAcquisition[] {
  const manualAcquisitions: IManualAcquisition[] = [];
  leaveTypes.forEach((leaveType) => {
    leaveType.initialBalances.forEach((balance) => {
      const balanceResourceId = (typeof balance.resourceId === 'string'?balance.resourceId:balance.resourceId._id)
      if (balanceResourceId === userId) {
        balance.leavePeriods.forEach((period) => {
          if(period.isManual) {
            manualAcquisitions.push(
              {
                balance: period.balance,
                periodDisplay: period.periodDisplay || '',
                type:leaveType._id,
                startDate: period.startDate
              });
          }
        })
      }
    });
  });

  return manualAcquisitions;
}

// Fonction pour calculer la somme des acquisitions manuelles pour un type de congé et un mois donné
export function calculateTotalManualAcquisitions(
  acquisitions: IManualAcquisition[],
  leaveTypeId: string,
  month: number, // Mois à comparer (0 pour janvier, 1 pour février, etc.),
  year: number
): number {
  return acquisitions.reduce((sum: number, acquisition: IManualAcquisition) => {
    const acquisitionMonth = new Date(acquisition.startDate).getMonth(); // getMonth() retourne un index de 0 à 11
    const acquisitionYear = new Date(acquisition.startDate).getFullYear(); // getMonth() retourne un index de 0 à 11

    // Vérifier si le type et le mois correspondent
    if (acquisition.type === leaveTypeId && acquisitionMonth === month && acquisitionYear === year) {
      return sum + acquisition.balance; // Ajouter la balance à la somme
    }
    return sum; // Retourner la somme actuelle si les conditions ne sont pas remplies
  }, 0);
}

// Fonction pour récupérer un tableau de ITakenDay à partir d'un tableau d'ILeave et d'un leaveType
export function getTakenDaysFromLeaves(leaves: ILeave[], leaveType: ILeaveTypes): ITakenDay[] {
  const takenDays: ITakenDay[] = [];
  
  leaves.forEach((leave) => {
    // Vérifier si le type de leave correspond au leaveType spécifié
    const leaveTypeId = typeof leave.type === "string"?leave.type:leave.type._id;
    const today = new Date();
    if (leaveTypeId === leaveType._id) {
      leave.staffingPeriod.forEach((period) => {
          const takenDay: ITakenDay = {
            days: period.days,
            startDate: new Date(period.startDate), // Assurez-vous que c'est un objet Date
            endDate: new Date(period.endDate), // Assurez-vous que c'est un objet Date
            isAM: period.isAM || false, // Par défaut à false si isAM est null ou undefined
            type: leave.type, // Utiliser le type de leave
          };

          takenDays.push(takenDay);
      });
    }
  });
  return takenDays;
}

// Fonction pour récupérer la date de fin du tableau selon l'année fiscale
export function getEndDate(user: IResource): Date  {
    const _firmId = user.firm ? user.firm : user._firmId

    if (typeof _firmId === "string") {
      return new Date(new Date().getFullYear(), 11, 1)
    }

    let endDate = getCurrentLeaveYearEnd(user)

    // Within 3 months of the current leave year end, also display the next leave year
    const today = new Date()
    today.setDate(1)
    const monthsUntilCurrentYearEnd =
      (endDate.getFullYear() - today.getFullYear()) * 12 + (endDate.getMonth() - today.getMonth())

    if (monthsUntilCurrentYearEnd <= 3) {
      endDate.setMonth(endDate.getMonth() + 12)
    }

    if (user.departureDate) {
      endDate = new Date(user.departureDate)
      endDate.setDate(1)
    }

    return endDate
}

// First month of the current leave year (aligned with getEndDate fiscal logic)
export function getCurrentLeaveYearStart(user: IResource): Date {
  const _firmId = user.firm ? user.firm : user._firmId

  if (typeof _firmId === "string") {
    return new Date(new Date().getFullYear(), 0, 1)
  }

  const fiscalMonthStart = getFiscalMonthStart(user)

  if (!fiscalMonthStart) {
    return new Date(new Date().getFullYear(), 0, 1)
  }

  const today = new Date()
  const startDate = new Date(today.getFullYear(), fiscalMonthStart, 1)

  // Before the fiscal start month: current leave year started last calendar year
  if (today.getMonth() < fiscalMonthStart) {
    startDate.setFullYear(startDate.getFullYear() - 1)
  }

  return startDate
}

// Last month of the current leave year (independent of table display extension)
export function getCurrentLeaveYearEnd(user: IResource): Date {
  const start = getCurrentLeaveYearStart(user)
  const end = new Date(start)
  end.setMonth(end.getMonth() + 11)

  if (user.departureDate) {
    const departure = new Date(user.departureDate)
    departure.setDate(1)
    if (departure < end) return departure
  }

  return end
}

// First month of the leave year immediately after the current one
export function getNextLeaveYearStart(user: IResource): Date {
  const start = getCurrentLeaveYearStart(user)
  const next = new Date(start)
  next.setMonth(next.getMonth() + 12)
  return next
}

// Last month of the leave year immediately after the current one
export function getNextLeaveYearEnd(user: IResource): Date {
  const start = getNextLeaveYearStart(user)
  const end = new Date(start)
  end.setMonth(end.getMonth() + 11)
  return end
}

// Returns true if the given year/month belongs to the next leave year (preview year)
export function isInNextLeaveYear(year: number, month: number, user: IResource): boolean {
  const date = new Date(year, month, 1)
  return date >= getNextLeaveYearStart(user) && date <= getNextLeaveYearEnd(user)
}

// Fonction pour récupérer les soldes initiaux par mois et leaveType
export function findLeavePeriodByTypeAndMonth(
  initialBalances: IInitialBalance[],
  type: string,
  month: number, // Mois à rechercher (1 pour janvier, 2 pour février, etc.)
  year: number
): number | undefined {
  let total = 0;
  let exists = false;
  for (const balance of initialBalances) {
    for (const leavePeriod of balance.leavePeriods) {
      if(leavePeriod.startDate){
        const leaveStartDate = new Date(leavePeriod.startDate);
        const leaveMonth = leaveStartDate.getMonth(); // getMonth() retourne un index de 0 à 11
        const leaveYear = leaveStartDate.getFullYear(); // getMonth() retourne un index de 0 à 11

        if (leavePeriod.type === type && leaveMonth === month && leaveYear == year) {
          total += leavePeriod.initialBalance; // cumule les soldes initiaux trouvés (si plusieurs périodes importées)
          exists = true; // pour ne pas renvoyer undefined
        }
      }
      
    }
  }
  return exists?total:undefined; // Retourne undefined si aucun élément n'est trouvé
}


// Fonction pour récupérer les périodes de suspension d'acquisition à partir des congés
export function getAcquisitionSuspensions(leaves: ILeave[], userLeaveTypes:ILeaveTypes[]): {startDate:Date, endDate:Date}[] {
  const data = leaves.map(leave =>  {
      return {...leave, type: userLeaveTypes.find(lt => {
                                const itemTypeId = typeof leave.type === 'string' ? leave.type : leave.type._id;
                                return lt._id === itemTypeId;})
             }
    }).filter(leave => {
      if (!leave.type || !leave.type.formula) return false;
      const formula = leave.type.formula;
      if (typeof formula === 'number') return false;
      return formula.noAcquisitionsAfterWeek!== undefined && formula.noAcquisitionsAfterWeek >= 0;
    });

  if (!Array.isArray(data) || data.length === 0) return [];

  const result :{startDate:Date, endDate:Date}[] = [];

  for (const item of data) {
    const periods = Array.isArray(item?.staffingPeriod) ? item.staffingPeriod : [];
    periods.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
    
    let startDate = new Date(periods[0].startDate);
    startDate.setDate(startDate.getDate() + ((typeof item?.type?.formula === 'number' ? 0 : item?.type?.formula?.noAcquisitionsAfterWeek || 0) * 7));
    const endDate = new Date(periods[periods.length-1].startDate);
    if(startDate<endDate || periods.length==1){
      result.push({startDate:startDate, endDate:endDate});
    }
    
  }
  return result;
}

export function getExcludedDays(leaves: ILeave[], userLeaveTypes:ILeaveTypes[]): {startDate:Date, endDate:Date, days:number}[] {
  const data = leaves.map(leave =>  {
      return {...leave, type: userLeaveTypes.find(lt => {
                                const itemTypeId = typeof leave.type === 'string' ? leave.type : leave.type._id;
                                return lt._id === itemTypeId;})
             }
    }).filter(leave => {
      if (!leave.type || !leave.type.formula) return false;
      const formula = leave.type.formula;
      if (typeof formula === 'number') return false;
      return formula.excludeAcquisition;
    });

  if (!Array.isArray(data) || data.length === 0) return [];

  const result :{startDate:Date, endDate:Date, days:number}[] = [];
  
  for (const item of data) {
    item.staffingPeriod.forEach((period: any) => {
        result.push(period);
    })
  }
  
  return result;
}


// Fonction principale pour générer le tableau
export function generateLeaveTable(user: IResource, leaves: ILeave[], leaveTypes: Array<ILeaveTypes & {formula:ILeaveFormula } >, publicHolidays: Array<IPublicHolidays>): ILeaveRow[] {
  const userLeaveTypes = filterLeaveTypes(leaveTypes, user);
  const initialBalances = getInitialBalancesForUser(user._id, userLeaveTypes);
  const manualAcquisitionsArray = getManualAcquisitionsForUser(user._id, userLeaveTypes);

  leaves = leaves.filter(leave => leave.status==1)

  const fiscalMonthStart = getFiscalMonthStart(user);
  
  const acquisitionSuspensionArray = getAcquisitionSuspensions(leaves, userLeaveTypes);
  const excludedDays = getExcludedDays(leaves, userLeaveTypes);

  // console.log(acquisitionSuspensionArray)
  
  const today = new Date();
  const months: ILeaveRow[] = [];
  

  // Trouver la date la plus ancienne parmi les initialBalances
  const contractStartDate = user.jobs.find(job => job.isStartDate)?.startDate||null;
  
  const earliestDate = initialBalances.length==0?new Date(contractStartDate||user.recruitmentDate):initialBalances.reduce((earliest, balance) => {
    const balanceDate = balance.leavePeriods[0]?new Date(balance.leavePeriods[0].startDate||new Date().getTime()):new Date();
    return balanceDate < earliest ? balanceDate : earliest;
  }, new Date());

  const endDate = getEndDate(user);

  user.earliestStartDate = earliestDate;

  let index = -1;
  for ( let d = new Date(earliestDate.getFullYear(), earliestDate.getMonth(), 1); d <= endDate; d.setMonth(d.getMonth() + 1) ) {
    index++;

    

    const year = d.getFullYear();
    const month = d.getMonth();
    const row: ILeaveRow = {
      year,
      month,
      display: `${year}-${(month + 1).toString().padStart(2, '0')}`,
      isNextYear: isInNextLeaveYear(year, month, user),
    };
    let getJobThisMonth = getJobInPeriod(user, new Date(year, month, d.getDate()));
    if(!getJobThisMonth){ getJobThisMonth = getJobInPeriod(user, new Date(year, month+1, d.getDate())); }

    const officeId = getJobThisMonth?.office ? getJobThisMonth?.office: (getJobThisMonth?.officeId._id? getJobThisMonth?.officeId :  (user.currentJob?.office ? user.currentJob?.office : user.officeId))

  if (typeof officeId === 'string' || !officeId) throw new Error(`officeId ${user.officeId} is not populated`);
    const publicHolidaysList = getPublicHolidays(year, getJobThisMonth, publicHolidays, officeId);

    userLeaveTypes.forEach((leaveType) => {
      
      // Acquisition des congés manuelle
      let acquiredManually = 0;
      let toBeAcquiredManually = 0;
      
      if(new Date(year, month, 1) < new Date(today.getFullYear(), today.getMonth()+1,1)) {
        acquiredManually = calculateTotalManualAcquisitions(manualAcquisitionsArray, leaveType._id, month, year);        
      }
      else{
        toBeAcquiredManually = calculateTotalManualAcquisitions(manualAcquisitionsArray, leaveType._id, month, year);        
      }

      // Acquisition des congés par formule
      let acquired = 0;
      let toBeAcquired = 0;
      const isAlumni = user.departureDate?new Date(user.departureDate)<new Date(year, month, 1):false;
  
      // Récupération des suspensions d'acquisition éventuelles
      var acquisitionSuspension = acquisitionSuspensionArray.find(suspension =>
        (new Date(suspension.startDate) <= new Date(year, month+1, 0) && new Date(suspension.endDate) >= new Date(year, month, 1))
      );

      var excludedDaysFiltered = excludedDays.filter(day => {
          return new Date(day.startDate).getFullYear() === year && new Date(day.startDate).getMonth() === month
        }
      );

      if(new Date(year, month, 1) < new Date(today.getFullYear(), today.getMonth(),1) && !isAlumni){
          acquired = (leaveType.formula.formula(year, month, user, publicHolidaysList, {period:acquisitionSuspension, excludedDays:excludedDaysFiltered})||0); // Passer des valeurs d'exemple pour publicHolidaysList et ms
      }
      else{
        if((leaveType.formula.isDay1Start||leaveType.formula.isAcquiredYearly) && year == today.getFullYear() && month == today.getMonth() && !isAlumni){
          acquired = (leaveType.formula.formula(year, month, user, publicHolidaysList, {period:acquisitionSuspension, excludedDays:excludedDaysFiltered})||0); // Passer des valeurs d'exemple pour publicHolidaysList et ms




        }
        else if(!isAlumni){
          toBeAcquired = (leaveType.formula.formula(year, month, user, publicHolidaysList, {period:acquisitionSuspension, excludedDays:excludedDaysFiltered})||0); // Passer des valeurs d'exemple pour publicHolidaysList et ms
        }
      }

      // Appliquer la multiplication du taux d'activité
      if(getJobThisMonth && leaveType.activityMultiplicator){
        const rate = (getJobThisMonth.rate/100);
        acquired = acquired*rate;
        toBeAcquired = toBeAcquired*rate;
      }
      if(new Date(year, month, 1) > endDate) {
        toBeAcquired = 0;
      }

      

      // Congés pris


      const takenDaysArray = getTakenDaysFromLeaves(leaves, leaveType)
      let taken = takenDaysArray.reduce((sum: number, takenDay: ITakenDay) => {
        const leaveMonth = takenDay.startDate.getMonth(); // Mois de la date de début
        const leaveYear = takenDay.startDate.getFullYear(); // Année de la date de début
        
        return leaveYear === year && leaveMonth === month && new Date(takenDay.startDate)<=today
          ? sum + takenDay.days
          : sum;
      }, 0);

      let toBeTaken = takenDaysArray.reduce((sum: number, takenDay: ITakenDay) => {
        const leaveMonth = takenDay.startDate.getMonth(); // Mois de la date de début
        const leaveYear = takenDay.startDate.getFullYear(); // Année de la date de début
        
        return leaveYear === year && leaveMonth === month && new Date(takenDay.startDate)>today
          ? sum + takenDay.days
          : sum;
      }, 0);

      if(leaveType.isHours && !!leaveType.hours && leaveType.hours>0){
        taken = taken*leaveType.hours;
        toBeTaken = toBeTaken*leaveType.hours;
      }

      // Vérification de l'initialBalance pour le mois
      const initialBalance = findLeavePeriodByTypeAndMonth(initialBalances, leaveType._id, month, year);

      let startBalance = 0;
      let lost = 0;


      if (initialBalance!==undefined) {
        // Si une initialBalance existe, l'utiliser comme solde de départ
        startBalance = initialBalance;
      } else if(index==0){
        // Ne rien faire car premier mois et pas de solde initial 
      } else{
        // récupérer le solde de fin du mois précédent
        startBalance = months[index-1][leaveType.display].endBalance;
        if (leaveType.formula.yearLimitTransfer!==undefined && startBalance > leaveType.formula.yearLimitTransfer && month==leaveType.formula.period[0]-1) {
          lost = leaveType.formula.yearLimitTransfer - startBalance;
          startBalance = leaveType.formula.yearLimitTransfer;
        }
      }    

      // Remise à 0 si resetTo0BOY est true;
      if(initialBalance===undefined && index!=0 && leaveType.formula.resetTo0BOY && month==0){
        startBalance = 0;
      }

      


      // Pour le premier mois, afficher le solde initial sans ajout d'acquisition
      if (initialBalance!==undefined) {
        row[leaveType.display] = {
          startBalance: startBalance, // Solde initial
          acquired: acquired,
          toBeAcquired: toBeAcquired,
          acquiredManually:acquiredManually,
          toBeAcquiredManually:toBeAcquiredManually,
          taken,
          toBeTaken,
          lost: lost,
          endBalance: startBalance + acquired + toBeAcquired + acquiredManually + toBeAcquiredManually - taken - toBeTaken, // Solde fin de mois
          isAlumni:isAlumni
        };
      } else {

        // Ajout des données au tableau
        row[leaveType.display] = {
          startBalance: startBalance, // Solde de fin de mois précédent
          acquired,
          toBeAcquired,
          acquiredManually,
          toBeAcquiredManually,
          taken,
          toBeTaken,
          lost: lost,
          endBalance: startBalance + acquired + toBeAcquired + acquiredManually + toBeAcquiredManually - taken - toBeTaken, // Solde final fin de mois,
          isAlumni
        };        
      }


      // Calcul du cumul acquis et pris sur la période
      const periodAcquired = (row[leaveType.display].acquired + row[leaveType.display].toBeAcquired + row[leaveType.display].acquiredManually + row[leaveType.display].toBeAcquiredManually) || 0;
      const periodTaken = (row[leaveType.display].taken + row[leaveType.display].toBeTaken) || 0;
      
      row[leaveType.display].periodCumulatedAcquired = periodAcquired;
      row[leaveType.display].periodCumulatedTaken = periodTaken;

      if(month==leaveType.formula.period[0]-1){
         row[leaveType.display].periodCumulatedAcquired = periodAcquired;
         row[leaveType.display].periodCumulatedTaken = periodTaken;    
      }
      else if(index>0){
        row[leaveType.display].periodCumulatedAcquired = periodAcquired + (months[index-1][leaveType.display]?.periodCumulatedAcquired||0);
        row[leaveType.display].periodCumulatedTaken = periodTaken + (months[index-1][leaveType.display]?.periodCumulatedTaken||0);
      }


      // Fonction de recalcul du solde de fin de mois personnalisée
      if(leaveType.formula.endBalanceFormula && typeof leaveType.formula.endBalanceFormula === 'function'){
        row[leaveType.display] = leaveType.formula.endBalanceFormula({month, balance: row[leaveType.display]});
      }

    });

    months.push(row);
  }

 
  return months;

}

function shiftMonthsBackward(data: any[], n: number): any[] {
  return data.map(entry => {
      let totalMonths = entry.year * 12 + entry.month - n;
      let newYear = Math.floor(totalMonths / 12);
      let newMonth = totalMonths % 12;

      return {
          ...entry,
          year: newYear,
          month: newMonth
      };
  });
}


export function generateHTMLTable(months: ILeaveRow[], leaveTypes: Array<ILeaveTypes>): string {
  // Génération du tableau HTML
  let htmlTable = `<table border="1" class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"><thead class="text-gray-500 dark:text-gray-400 bg-fade"><tr><th class="sticky left-0 px-4 py-2 bg-fade">Type de Congé</th><th class="sticky left-16 px-4 py-2 bg-fade">Type d'Information</th>`;

  // Ajouter les mois en tant que colonnes
  months.forEach((row) => {
    htmlTable += `<th class="px-4 py-2">${row.display}</th>`;
  });
  htmlTable += `</tr></thead>`;

  // Créer une ligne pour chaque type de congé et chaque type d'information
  leaveTypes.sort(leaveType => leaveType.order).forEach((leave) => {
    const data = months.map((row) => row[leave.display] || {
      startBalance: 0,
      acquired: 0,
      toBeAcquired:0,
      acquiredManually:0,
      toBeAcquiredManually:0,
      taken: 0,
      toBeTaken: 0,
      lost: 0,
      endBalance: 0
    });

    // Ajouter les types d'information
    const infoTypes = ['Solde en début de mois', 'Acquis', 'A acquérir', 'Acquis manuellement', 'A acquérir manuellement', 'Pris', 'A prendre', 'Perdus', 'Solde en fin de mois'];

    infoTypes.forEach((infoType, index) => {
      htmlTable += `<tr><td class="sticky left-0 w-32 bg-base px-4 py-2 z-10">${leave.display}</td><td class="sticky left-16 bg-base px-4 py-2 z-10" ${infoType=='Solde en fin de mois'?"class='bg-fade'":""}>${infoType}</td>`; // Type de congé et type d'information

      // Remplir les données pour chaque mois
      months.forEach((row) => {
        const monthData = row[leave.display] || {
          startBalance: 0,
          acquired: 0,
          taken: 0,
          toBeTaken: 0,
          lost: 0,
          endBalance: 0,
        };

        // Choisir la valeur appropriée selon le type d'information
        let value;
        switch (infoType) {
          case 'Solde en début de mois':
            value = monthData.startBalance;
            break;
          case 'Acquis':
            value = monthData.acquired;
            break;
            case 'A acquérir':
              value = monthData.toBeAcquired;
              break;
            case 'Acquis manuellement':
              value = monthData.acquiredManually;
              break;
            case 'A acquérir manuellement':
            value = monthData.toBeAcquiredManually;
            break;
          case 'Pris':
            value = monthData.taken;
            break;
          case 'A prendre':
              value = monthData.toBeTaken;
              break;
          case 'Perdus':
            value = monthData.lost;
            break;
          case 'Solde en fin de mois':
            value = monthData.endBalance;
            break;
          default:
            value = 0;
        }

        htmlTable += `<td ${infoType=='Solde en fin de mois'?"class='bg-fade'":""}>${value.toFixed(2)}</td>`; // Ajouter la valeur pour le mois
      });

      htmlTable += `</tr>`;
    });
  });

  htmlTable += `</table>`;
  return htmlTable;
}

function getUniqueYears(
  months: Array<{ year: number; month: number; display: string; [key: string]: any }>, 
  fiscalMonthStart: number
): Array<{ year: number; display: string }> {
  
  const yearsSet: Set<number> = new Set();
  
  months.forEach(item => {
    if (typeof item.year === "number") { // Vérification que l'année est bien un nombre
      // yearsSet.add(item.year);
      yearsSet.add(getFiscalYear(new Date(item.year, item.month, 1), fiscalMonthStart))
    }
  });

  const yearArray = Array.from(yearsSet).map(year => Number(year));
  const today = new Date();
  const fiscalYear = getFiscalYear(new Date(months[0]?.year||today.getFullYear(), months[0]?.month||today.getMonth(), 1), fiscalMonthStart);

  let result: Array<{ year: number; display: string }> = [];
  
  yearArray.forEach((year, index) => 
  {
    
    result.push( {
      year: fiscalYear+index, 
      display: fiscalMonthStart ? fiscalYear+index + " - " + (fiscalYear+index + 1): (fiscalYear+index).toString()
    })
  });
  
  return result;
}

function sumMonthsToNow(display: string, months: Array<{ year: number; month: number; display: string; [key: string]: any }>, year: number, type: string) {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  return months
      .filter(item => item.year === year && (item.year < currentYear || item.month <= currentMonth))
      .reduce((sum, item) => {

// if(!item[display]){
//   console.log(display, item)
// }

          const total = (item[display]?item[display][type]:0);
          return sum + total;
      }, 0);
}


function sumMonths(display: string, months: Array<{ year: number; month: number; display: string; [key: string]: any }>, year: number, type: string) {
  return months
      .filter(item => item.year === year)
      .reduce((sum, item) => {
          const total = item[display][type];
          return sum + total;
      }, 0);
}

function getFirstRow(months: Array<{ year: number; month: number; display: string; [key: string]: any }>, type: string, year: number):ILeaveRow | null {
  for (const item of months) {
    if (item.year === year && item[type] && item[type].startBalance !== undefined) {
      return item[type];
  }
  }
  return null;
}

function getLastEndBalance(months: Array<{ year: number; month: number; display: string; [key: string]: any }>, type: string, year: number) {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const monthIndex = year==currentYear?currentMonth:11;
    for (let i = months.length - 1; i >= 0; i--) {
        if (months[i].year === year && months[i].month==monthIndex && months[i][type] && months[i][type].endBalance !== undefined) {
          // return months[i][type].startBalance + months[i][type].acquired + months[i][type].acquiredManually - months[i][type].taken;
          return months[i][type].endBalance;
        }
    }
    return null;
}


function getLastYearBalance(months: Array<{ year: number; month: number; display: string; [key: string]: any }>, type: string, year: number) {
  
  var monthArray = [];
  for (let i = months.length - 1; i >= 0; i--) {
      if (months[i].year === year 
        // && months[i].month==11 
        && months[i][type] && months[i][type].endBalance !== undefined) {
        // return months[i][type].endBalance;
        monthArray.push(months[i][type])
      }
  }

  if(monthArray.length>1){
    return monthArray[0].endBalance;
  }
  
  // if(year==2024 && type=="Vacaciones"){
  //   console.log(months)
  // }
  return null;
}

function getOneRow(months: Array<{ year: number; month: number; display: string; [key: string]: any }>, type: string, year: number, month: number):ILeaveRow | null {
  for (const item of months) {
    if (item.year === year && item.month === month && item[type]) {
      return item[type];
  }
  }
  return null;
}


function getRemainingMonths(): number[] {
  const currentMonth = new Date().getMonth(); // Mois actuel (0 = Janvier, 11 = Décembre)
  return Array.from({ length: 12 - currentMonth }, (_, i) => currentMonth + i);
}

export function generateSummaryData(months: Array<{ year: number; month: number; display: string; [key: string]: any }>, leaveTypes: Array<ILeaveTypes>,  fiscalMonthStart: number) {
  
  const balanceMonths = months.filter(month => (month.year <= new Date().getFullYear() ) );
  
  const yearArray = getUniqueYears(months, fiscalMonthStart);



  if(fiscalMonthStart>0){
    months = shiftMonthsBackward(months, fiscalMonthStart);
 }

  const summaryData: any[] = [];

  leaveTypes.sort((a, b) => a.order - b.order).forEach((leave) => {
    const monthsForBalance = months.filter(month => !month.isNextYear)

    const leaveData: any = {
      display: leave.display,
      _id: leave._id,
      years: {},
      balance: {},
    };

    

    const lastYearOfMonth = yearArray[yearArray.length - 1]?.year||new Date().getFullYear();
    const latestActiveYear = lastYearOfMonth <= new Date().getFullYear() ? lastYearOfMonth : new Date().getFullYear();
    const currentFiscalYear = getFiscalYear(new Date(), fiscalMonthStart)
    const isCurrentYear = (year: number) => year === new Date().getFullYear(); 

    // console.log(lastYearOfMonth, latestActiveYear)

    var futureLeaves = 0;
    // getRemainingMonths().forEach((month) => {
    //   futureLeaves += getOneRow(balanceMonths, leave.display, latestActiveYear, month)?.toBeTaken || 0;
    // });
    futureLeaves = monthsForBalance.reduce((n, item) => {
      if(item.year >= currentFiscalYear){
        n += item[leave.display]?.toBeTaken||0;
      }
      return n;
    }, 0);

    let hasValues = 0;

    yearArray.forEach((year) => {


      let monthsInYear = months.reduce((arr, item) => {
        if(item.year === year.year){
          arr.push({
            year:item.year,
            month:item.month,
            display:item.display,
            ...item[leave.display]
          })
        }
        return arr;
      }, [] as any[]);

      let acquired = monthsInYear.reduce((sum, item) => {
        const total = (item?.acquired||0) + (item?.acquiredManually||0);
        return sum + total;
      }, 0);
     
      let taken = monthsInYear.reduce((sum, item) => {
        const total = (item?.taken||0) + (item?.toBeTaken||0);
        return sum + total;
      }, 0);

      let startBalance = monthsInYear.length>0?monthsInYear[0]?.startBalance||0:0;

      let futureLeavesThisYear = 0;
      let lastMonth = monthsInYear.length>0?monthsInYear[monthsInYear.length-1]:[];

      if(isCurrentYear(year.year)){
        lastMonth = monthsInYear.find(m => m.month == new Date().getMonth())||lastMonth;

        futureLeavesThisYear = months.reduce((n, item) => {
        if(item.year >= year.year){
          n += item[leave.display]?.toBeTaken||0;
        }
        return n;
      }, 0);
      }

      let endBalance = lastMonth?(
        (lastMonth?.startBalance||0) + 
        (lastMonth?.acquired||0) - 
        (lastMonth?.taken||0) -
        futureLeavesThisYear):0;

      leaveData.years[year.year] = {
        startBalance: startBalance,
        acquired: acquired,
        taken: taken,
        endBalance: endBalance,
      }

      if(year.year === lastYearOfMonth ||year.year == latestActiveYear || year.year == new Date().getFullYear()){
        hasValues += leaveData.years[year.year].startBalance;
        hasValues += leaveData.years[year.year].acquired;
        hasValues += leaveData.years[year.year].taken;
      }

    });

    let fiscalMonthShift = new Date();
    fiscalMonthShift.setMonth(new Date().getMonth() - fiscalMonthStart);
    
    const currentMonthIndex = monthsForBalance.findIndex(m => m.year == currentFiscalYear && m.month == fiscalMonthShift.getMonth());
    const currentMonth = currentMonthIndex!==-1?monthsForBalance[currentMonthIndex]:null;
    const previousMonth = (currentMonthIndex !== -1 && currentMonthIndex > 0) ? monthsForBalance[currentMonthIndex - 1] : null;
    const currentMonthData = currentMonth?.[leave.display]
    const previousMonthData = previousMonth?.[leave.display]


    
    

    let futureAcquisitions = monthsForBalance.reduce((n, item) => {
      if(item.year >= currentFiscalYear){
        n += item[leave.display]?.toBeAcquired||0;
      }
      return n;
    }, 0);


    let monthsInYear = monthsForBalance.reduce((arr, item) => {
      if(item.year === currentFiscalYear){
        arr.push({
          year:item.year,
          month:item.month,
          display:item.display,
          ...item[leave.display]
        })
      }
      return arr;
    }, [] as any[]);

    let balanceEOY = monthsInYear.length>0?monthsInYear[monthsInYear.length-1]?.endBalance||0:0;




    let balanceWithoutFutureLeave = (currentMonthData?.startBalance ?? 0) + (currentMonthData?.acquired ?? 0) - (currentMonthData?.taken ?? 0);
    
    leaveData.balance = {
      EOLM: previousMonthData?.endBalance ?? 0,
      balanceWithoutFutureLeave,
      futureLeaves:futureLeaves,
      balanceWithFutureLeaves:balanceWithoutFutureLeave - futureLeaves,
      futureAcquisitions,
      balanceEOY,
      isManual: typeof leave.formula === 'number'?false:(leave.formula?.isManual||false),
    };

    leaveData.hasValues = hasValues!==0;

    summaryData.push(leaveData);
    
  });
  
  return { yearArray, summaryData };
}

export function generateHTMLTableSummary(months: Array<{ year: number; month: number; display: string; [key: string]: any }>, leaveTypes: Array<ILeaveTypes>,  fiscalMonthStart: number): string {
  const { yearArray, summaryData } = generateSummaryData(months, leaveTypes, fiscalMonthStart);

  let htmlTable = `<div class="relative overflow-x-auto">
    <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
    <thead class="text-xs bg-fade uppercase">
      <tr>
        <th></th>`;

  yearArray.forEach((year) => {
    htmlTable += `<th colspan="4" scope="col" class="sticky left-0 bg-fade px-4 py-2">${year.display}</th>`;
  });

  htmlTable += `<th colspan="6" class="bg-fade text-nowrap px-4 py-2 sticky left-0">Balance of current year</th>
      </tr>
      <tr>
        <th class="px-4 py-2 sticky left-0 bg-fade">Leaves type</th>`;

  yearArray.forEach(() => {
    htmlTable += `<th class="px-4 py-2">Start</th>
          <th class="px-4 py-2">Acqu.</th>
          <th class="px-4 py-2">Cons.</th>
          <th class="px-4 py-2">End</th>`;
  });

  htmlTable += `<th class="text-nowrap px-4 py-2 bg-fade">Balance EOLM</th>
        <th class="text-nowrap px-4 py-2 bg-fade">Balance to date without future leaves</th>
        <th class="text-nowrap px-4 py-2 bg-fade">Future leave</th>
        <th class="text-nowrap px-4 py-2 bg-fade">Balance with future leaves</th>
        <th class="text-nowrap px-4 py-2 bg-fade">Acquisition left before EOY</th>
        <th class="text-nowrap px-4 py-2 bg-fade">Balance EOY</th>
      </tr>
    </thead>
    <tbody>`;

  summaryData.forEach((leave) => {
    htmlTable += `<tr class="border-b bg-base dark:border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600">
          <td class="px-4 py-2 color-base whitespace-nowrap sticky left-0 bg-base">${leave.display}</td>`;

    yearArray.forEach((year) => {
      const data = leave.years[year.year];
      htmlTable += `<td class="px-4 py-2">${data.startBalance.toFixed(2)}</td>
            <td class="px-4 py-2">${data.acquired.toFixed(2)}</td>
            <td class="px-4 py-2">${data.taken.toFixed(2)}</td>
            <td class="px-4 py-2">${data.endBalance.toFixed(2)}</td>`;
    });

    const balance = leave.balance;
    htmlTable += `<td class="bg-fade px-4 py-2">${balance.EOLM.toFixed(2)}</td>
          <td class="bg-fade px-4 py-2">${balance.balanceWithoutFutureLeave.toFixed(2)}</td>
          <td class="bg-fade px-4 py-2">${balance.futureLeaves.toFixed(2)}</td>
          <td class="bg-fade px-4 py-2">${balance.balanceWithFutureLeaves.toFixed(2)}</td>
          <td class="bg-fade px-4 py-2">${balance.futureAcquisitions.toFixed(2)}</td>
          <td class="bg-fade px-4 py-2">${balance.balanceEOY.toFixed(2)}</td>
        </tr>`;
  });

  htmlTable += `</tbody></table></div>`;
  return htmlTable;
}


export function generateHTMLTableSummaryV1(months: Array<{ year: number; month: number; display: string; [key: string]: any }>, leaveTypes: Array<ILeaveTypes>, fiscalMonthStart:number): string {
  const { yearArray, summaryData } = generateSummaryData(months, leaveTypes, fiscalMonthStart);

  let htmlTable = `<div class="table-responsive">
    <table class="table table-bordered table-striped">
    <thead class="thead-inverse">
      <tr>
        <th></th>`;

  yearArray.forEach((year) => {
    htmlTable += `<th colspan="4" class="text-center">${year.display}</th>`;
  });

  htmlTable += `<th colspan="6" class="text-center">Balance of current year</th>
      </tr>
      <tr>
        <th class="text-center">Leaves type</th>`;

  yearArray.forEach(() => {
    htmlTable += `<th class="text-center">Start</th>
          <th class="text-center">Acqu.</th>
          <th class="text-center">Cons.</th>
          <th class="text-center">End</th>`;
  });

  htmlTable += `<th class="text-center">Balance EOLM</th>
        <th class="text-center">Balance to date without future leaves</th>
        <th class="text-center">Future leave</th>
        <th class="text-center">Balance with future leaves</th>
        <th class="text-center">Acquisition left before EOY</th>
        <th class="text-center">Balance EOY</th>
      </tr>
    </thead>
    <tbody>`;

  summaryData.forEach((leave) => {
    htmlTable += `<tr>
          <td class="text-center">${leave.display}</td>`;

    yearArray.forEach((year) => {
      const data = leave.years[year.year];
      htmlTable += `<td class="text-center">${data.startBalance.toFixed(2)}</td>
            <td class="text-center">${data.acquired.toFixed(2)}</td>
            <td class="text-center">${data.taken.toFixed(2)}</td>
            <td class="text-center">${data.endBalance.toFixed(2)}</td>`;
    });

    const balance = leave.balance;
    htmlTable += `<td class="text-center">${balance.EOLM.toFixed(2)}</td>
          <td class="text-center">${balance.balanceWithoutFutureLeave.toFixed(2)}</td>
          <td class="text-center">${balance.futureLeaves.toFixed(2)}</td>
          <td class="text-center">${balance.balanceWithFutureLeaves.toFixed(2)}</td>
          <td class="text-center">${balance.futureAcquisitions.toFixed(2)}</td>
          <td class="text-center">${balance.balanceEOY.toFixed(2)}</td>
        </tr>`;
  });

  htmlTable += `</tbody></table></div>`;
  return htmlTable;
}
